export const VoiceType = {
    MAN:'Man',
    WOMAN:'Woman',
    CHILD:'Child',
    ELDERLY:'Elderly'
}
